import type { Message } from "../api/client.js";

interface Props {
  messages: Message[];
}

export function MessageList({ messages }: Props) {
  return (
    <div className="space-y-4">
      {messages.map((msg, i) => (
        <MessageBubble key={i} message={msg} />
      ))}
    </div>
  );
}

function MessageBubble({ message }: { message: Message }) {
  const isUser = message.role === "user";
  const isSystem = message.role === "system";
  const isTool = message.role === "tool";

  if (isSystem) {
    return (
      <div className="rounded-lg bg-amber-50 px-4 py-2.5 text-xs text-amber-800">
        {message.content}
      </div>
    );
  }

  if (isTool) {
    return (
      <div className="rounded-lg border border-ink-100 bg-surface-1 px-4 py-2.5">
        <div className="mb-1 flex items-center gap-2">
          <span className="badge-blue">{message.toolName}</span>
          <span className="font-mono text-2xs text-ink-400">{message.toolCallId}</span>
        </div>
        <pre className="overflow-x-auto text-xs text-ink-700">{message.content}</pre>
      </div>
    );
  }

  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
          isUser
            ? "bg-ink-950 text-white"
            : "bg-white text-ink-800 shadow-subtle border border-ink-100"
        }`}
      >
        {/* Provenance label for assistant messages */}
        {!isUser && (
          <div className="mb-1.5 flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-accent-100">
              <svg className="h-2.5 w-2.5 text-accent-700" viewBox="0 0 16 16" fill="currentColor">
                <circle cx="8" cy="5" r="2.5" />
                <path d="M3 14c0-2.8 2.2-5 5-5s5 2.2 5 5" />
              </svg>
            </span>
            <span className="text-2xs font-medium text-ink-400">Agent</span>
          </div>
        )}

        <div className="whitespace-pre-wrap">{message.content}</div>
      </div>
    </div>
  );
}
